// Isolated so callers that only need to identify the SH-82 source revision
// do not pull the reviewed-table JSON payloads into their bundle.
export const SH82_CHECKSUM = '0c40561521287ffa0198e88e7a5bd049d6700758b39fd18d2ff9f35d17cb7e60';
